import {makeAutoObservable} from 'mobx';

export const PTInchRatio = 72;

export enum Size {
    PT12 = 12,
    PT16 = 16,
    PT20 = 20,
    PT24 = 24,
    PT28 = 28,
    PT32 = 32,
    PT36 = 36,
    PT40 = 40,
}

export enum LineHeight {
    PT12 = Size.PT12 / PTInchRatio,
    PT16 = Size.PT16 / PTInchRatio,
    PT20 = Size.PT20 / PTInchRatio,
    PT24 = Size.PT24 / PTInchRatio,
    PT28 = Size.PT28 / PTInchRatio,
    PT32 = Size.PT32 / PTInchRatio,
    PT36 = Size.PT36 / PTInchRatio,
    PT40 = Size.PT40 / PTInchRatio,
}

export enum Font {
    Roboto = 1,
    LibreBaskerville = 2,
    Carlito = 3,
    TimesNewRoman = 4,
    EBGaramond = 5,
    NunitoSans = 6,
    CrimsonText = 7,
    IBMPlexMono = 8,
}

export const FONT_FAMILY_MAP: Record<Font, string> = {
    [Font.Roboto]: 'Roboto, Poppins, Open Sans, Proxima Nova, system-ui, sans-serif',
    [Font.LibreBaskerville]: '"Libre Baskerville", Georgia, "Times New Roman", serif',
    [Font.Carlito]: 'Carlito, Calibri, Arial, sans-serif',
    [Font.TimesNewRoman]: '"Times New Roman", Times, serif',
    [Font.EBGaramond]: '"EB Garamond", Garamond, "Times New Roman", serif',
    [Font.NunitoSans]: '"Nunito Sans", Nunito, system-ui, sans-serif',
    [Font.CrimsonText]: '"Crimson Text", Georgia, "Times New Roman", serif',
    [Font.IBMPlexMono]: '"IBM Plex Mono", Consolas, "Courier New", monospace',
};

export const FONT_OPTIONS = [
    {value: Font.Roboto, label: 'Roboto'},
    {value: Font.LibreBaskerville, label: 'Libre Baskerville'},
    {value: Font.Carlito, label: 'Carlito'},
    {value: Font.TimesNewRoman, label: 'Times New Roman'},
    {value: Font.EBGaramond, label: 'EB Garamond'},
    {value: Font.NunitoSans, label: 'Nunito Sans'},
    {value: Font.CrimsonText, label: 'Crimson Text'},
    {value: Font.IBMPlexMono, label: 'IBM Plex Mono'},
];

export const FONT_SIZES = [
    {value: Size.PT12, label: Size[Size.PT12]},
    {value: Size.PT16, label: Size[Size.PT16]},
    {value: Size.PT20, label: Size[Size.PT20]},
    {value: Size.PT24, label: Size[Size.PT24]},
    {value: Size.PT28, label: Size[Size.PT28]},
    {value: Size.PT32, label: Size[Size.PT32]},
    {value: Size.PT36, label: Size[Size.PT36]},
    {value: Size.PT40, label: Size[Size.PT40]},
];

export type EPLine = {
    text: string;
    lineHeight: LineHeight;
    size: Size;
    bold: boolean;
    italic: boolean;
};

class EngravedPlateExtendedStore {
    public lines: EPLine[] = [];
    public fontFamily: string;

    constructor() {
        makeAutoObservable(this);
    }
}

export const engravedPlateExtendedStore = new EngravedPlateExtendedStore();
